/**
 * @author: dongjing
 * @file: description
 * @Date: 2019-12-02 12:15:36
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-06-08 19:59:46
 */
import React from 'react';
import history from '@src/common/history';
import { openTargetBlankPage } from '@src/utils';
import { Popconfirm } from 'antd';
import { IconFont } from '@src/features/common/Icon';
import SFCTitleContent from './SFCTitleContent';
import './SFCVoteTextImage.less';

interface Props {
  data: any;
  index: number;
  tabKey?: string;
  onFollow: (data: { voteQuestionId: number; index?: number; targetType: boolean }) => void;
  enableTargetBlank?: boolean;
  openTargePage?: (targetUri: string) => void;
  /** 是否是个人页面调用 */
  personal?: boolean;
  /** 删除投票 */
  handleRemove?: (voteQuestionId: number) => void;
}

const SFCVoteTextImage: React.SFC<Props> = (props: Props) => {
  const openTargePageDefault = (targetUri: string) => {
    if (!props.enableTargetBlank) {
      history.push(targetUri);
    } else {
      openTargetBlankPage(targetUri);
    }
  };

  const {
    data,
    index,
    openTargePage = openTargePageDefault,
    personal = false,
    handleRemove
  } = props;

  const onQuestion = () => {
    openTargePage(`/vote/info/${data.voteQuestionId}`);
  };

  const onProfile = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    openTargePage(`/personal/${data.votePublishUser.username}`);
  };

  const onFollow = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    props.onFollow({ voteQuestionId: data.voteQuestionId, index, targetType: !data.concerned });
  };

  const voteListRemove = () => {
    handleRemove && handleRemove(data.voteQuestionId);
  };

  return (
    <div className="k-tech-feed-item k-tech-com-vote-text-image">
      <div className="k-tech-cursor-pointer" onClick={onQuestion}>
        <SFCTitleContent title={data.voteQuestionTitle} content={data.voteQuestionSubContent} />
      </div>

      <div className="bottom">
        <div className="vote-bottom-left">
          <div className="meta">
            <span
              className="k-tech-hover-underscore k-tech-cursor-pointer name"
              onClick={onProfile}
            >
              {data.votePublishUser.name}
            </span>
          </div>
          {!personal && (
            <ul className="action">
              <li className="k-tech-cursor-pointer action__item" onClick={onFollow}>
                {data.concerned ? '已关注' : '关注'}
              </li>
            </ul>
          )}
        </div>
        {personal && (
          <Popconfirm title="确认删除？" onConfirm={voteListRemove} okText="确认" cancelText="取消">
            <div className="option-item option-delete">
              <IconFont type="icon-ashcan" className="option-ico" />
              删除
            </div>
          </Popconfirm>
        )}
      </div>
    </div>
  );
};

export default React.memo(SFCVoteTextImage);
